<template lang="pug">
  v-app.app
    slot
</template>

<script type="module">

export default {
  data: function () {
    return {
    }
  },
}
</script>

<style scoped>
.app {
  min-height: auto !important;
  background: transparent !important;
}
</style>

<style>
.v-application--wrap {
  min-height: auto !important;
}
</style>
